import type * as React from 'react';

import SvgAccount from './SvgAccount';
import SvgAccountFull from './SvgAccountFull';
import SvgAI from './SvgAI';
import SvgAlertCircle from './SvgAlertCircle';
import SvgAmericanFootball from './SvgAmericanFootball';
import SvgAnalysis from './SvgAnalysis';
import SvgArrowBack from './SvgArrowBack';
import SvgArrowBackCircle from './SvgArrowBackCircle';
import SvgArrowDown from './SvgArrowDown';
import SvgArrowDownCircle from './SvgArrowDownCircle';
import SvgArrowForward from './SvgArrowForward';
import SvgArrowForwardCircle from './SvgArrowForwardCircle';
import SvgArrowUp from './SvgArrowUp';
import SvgArrowUpCircle from './SvgArrowUpCircle';
import SvgAthletics from './SvgAthletics';
import SvgAussieRules from './SvgAussieRules';
import SvgAZ from './SvgAZ';
import SvgBadminton from './SvgBadminton';
import SvgBaseball from './SvgBaseball';
import SvgBasketball from './SvgBasketball';
import SvgBetslip from './SvgBetslip';
import SvgBettingSites from './SvgBettingSites';
import SvgBettingSplits from './SvgBettingSplits';
import SvgBowls from './SvgBowls';
import SvgBoxing from './SvgBoxing';
import SvgBurgerMenu from './SvgBurgerMenu';
import SvgCasino from './SvgCasino';
import SvgCombatSports from './SvgCombatSports';
import SvgCricket from './SvgCricket';
import SvgCrypto from './SvgCrypto';
import SvgCup from './SvgCup';
import SvgCycling from './SvgCycling';
import SvgDarts from './SvgDarts';
import SvgDiscord from './SvgDiscord';
import SvgEducation from './SvgEducation';
import SvgESports from './SvgESports';
import SvgEyes from './SvgEyes';
import SvgEyesOff from './SvgEyesOff';
import SvgFilter from './SvgFilter';
import SvgFilterSliders from './SvgFilterSliders';
import SvgFinance from './SvgFinance';
import SvgGolf from './SvgGolf';
import SvgGreyhounds from './SvgGreyhounds';
import SvgHandball from './SvgHandball';
import SvgHitRate from './SvgHitRate';
import SvgHome from './SvgHome';
import SvgHorseRacing from './SvgHorseRacing';
import SvgIceHockey from './SvgIceHockey';
import SvgInfoCircle from './SvgInfoCircle';
import SvgInsights from './SvgInsights';
import SvgLacrosse from './SvgLacrosse';
import SvgLogOut from './SvgLogOut';
import SvgMatchups from './SvgMatchups';
import SvgMotorsport from './SvgMotorsport';
import SvgNewWindow from './SvgNewWindow';
import SvgNoWifi from './SvgNoWifi';
import SvgOffersFull from './SvgOffersFull';
import SvgOffersOutline from './SvgOffersOutline';
import SvgPadlock from './SvgPadlock';
import SvgPolitics from './SvgPolitics';
import SvgPool from './SvgPool';
import SvgPopular from './SvgPopular';
import SvgPositiveEV from './SvgPositiveEV';
import SvgPremiumTipsUS from './SvgPremiumTipsUS';
import SvgRowing from './SvgRowing';
import SvgRugby from './SvgRugby';
import SvgSearch from './SvgSearch';
import SvgSnooker from './SvgSnooker';
import SvgSoccer from './SvgSoccer';
import SvgSort from './SvgSort';
import SvgSquash from './SvgSquash';
import SvgStarFull from './SvgStarFull';
import SvgStarOutline from './SvgStarOutline';
import SvgTableTennis from './SvgTableTennis';
import SvgTennis from './SvgTennis';
import SvgTickCircle from './SvgTickCircle';
import SvgTipsFire from './SvgTipsFire';
import SvgTools from './SvgTools';
import SvgTrash from './SvgTrash';
import SvgTrends from './SvgTrends';
import SvgTV from './SvgTV';
import SvgVolleyball from './SvgVolleyball';
import SvgWinterSports from './SvgWinterSports';
import SvgXCross from './SvgXCross';

/**
 * The UK icon set, keyed by its Figma name.
 *
 * An explicit object literal rather than a re-export barrel like `icons/index.ts`, because two
 * Figma names — `A-Z` and `E-Sports` — are not valid JavaScript identifiers and cannot be
 * `export { default as … }`ed. The keys are the CMS-facing contract, so they stay byte-identical
 * to Figma; the component names beside them are only local.
 */
export const ukIcons: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  'A-Z': SvgAZ,
  AI: SvgAI,
  Account: SvgAccount,
  Account_Full: SvgAccountFull,
  Alert_Circle: SvgAlertCircle,
  American_Football: SvgAmericanFootball,
  Analysis: SvgAnalysis,
  Arrow_Back: SvgArrowBack,
  Arrow_Back_Circle: SvgArrowBackCircle,
  Arrow_Down: SvgArrowDown,
  Arrow_Down_Circle: SvgArrowDownCircle,
  Arrow_Forward: SvgArrowForward,
  Arrow_Forward_Circle: SvgArrowForwardCircle,
  Arrow_Up: SvgArrowUp,
  Arrow_Up_Circle: SvgArrowUpCircle,
  Athletics: SvgAthletics,
  Aussie_Rules: SvgAussieRules,
  Badminton: SvgBadminton,
  Baseball: SvgBaseball,
  Basketball: SvgBasketball,
  Betslip: SvgBetslip,
  Betting_Sites: SvgBettingSites,
  Betting_Splits: SvgBettingSplits,
  Bowls: SvgBowls,
  Boxing: SvgBoxing,
  Burger_Menu: SvgBurgerMenu,
  Casino: SvgCasino,
  Combat_Sports: SvgCombatSports,
  Cricket: SvgCricket,
  Crypto: SvgCrypto,
  Cup: SvgCup,
  Cycling: SvgCycling,
  Darts: SvgDarts,
  Discord: SvgDiscord,
  'E-Sports': SvgESports,
  Education: SvgEducation,
  Eyes: SvgEyes,
  Eyes_Off: SvgEyesOff,
  Filter: SvgFilter,
  Filter_Sliders: SvgFilterSliders,
  Finance: SvgFinance,
  Golf: SvgGolf,
  Greyhounds: SvgGreyhounds,
  Handball: SvgHandball,
  Hit_Rate: SvgHitRate,
  Home: SvgHome,
  Horse_Racing: SvgHorseRacing,
  Ice_Hockey: SvgIceHockey,
  Info_Circle: SvgInfoCircle,
  Insights: SvgInsights,
  Lacrosse: SvgLacrosse,
  Log_Out: SvgLogOut,
  Matchups: SvgMatchups,
  Motorsport: SvgMotorsport,
  New_Window: SvgNewWindow,
  No_Wifi: SvgNoWifi,
  Offers_Full: SvgOffersFull,
  Offers_Outline: SvgOffersOutline,
  Padlock: SvgPadlock,
  Politics: SvgPolitics,
  Pool: SvgPool,
  Popular: SvgPopular,
  Positive_EV: SvgPositiveEV,
  Premium_Tips_US: SvgPremiumTipsUS,
  Rowing: SvgRowing,
  Rugby: SvgRugby,
  Search: SvgSearch,
  Snooker: SvgSnooker,
  Soccer: SvgSoccer,
  Sort: SvgSort,
  Squash: SvgSquash,
  Star_Full: SvgStarFull,
  Star_Outline: SvgStarOutline,
  TV: SvgTV,
  Table_Tennis: SvgTableTennis,
  Tennis: SvgTennis,
  Tick_Circle: SvgTickCircle,
  Tips_Fire: SvgTipsFire,
  Tools: SvgTools,
  Trash: SvgTrash,
  Trends: SvgTrends,
  Volleyball: SvgVolleyball,
  Winter_Sports: SvgWinterSports,
  X_Cross: SvgXCross,
};
